/** Per-user local-storage flag: set once the user dismisses the settings-moved pointer for good. */
export const SETTINGS_NAV_GUIDE_SHOWN_KEY = 'settings_nav_guide_shown';

/** Gives the appbar time to mount before the popover looks for its anchor. */
export const SETTINGS_NAV_GUIDE_DELAY = 800;

/** The appbar item the pointer anchors to. */
export const SETTINGS_NAV_GUIDE_ANCHOR_ID = 'appbar-settings-item';

/**
 * Accounts created on or after this instant never see the "Settings moved here" pointer.
 * Deliberately 12 Oct 2026 (product decision), later than the settings redesign merge on
 * 22 Sep 2026, so no account that used the old profile menu misses it; a few accounts created
 * in between see it once, which is the cheaper mistake. Not a typo: JS months are 0-based.
 */
export const SETTINGS_MOVED_AT = Date.UTC(2026, 9, 12);
